
    import '/opt/buildhome/repo/packages/x/components/use-x-agent/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["components-use-x-agent-demo-preset","components-use-x-agent-demo-requestparams","components-use-x-agent-demo-custom","components-use-x-agent-demo-model","components-use-x-agent-demo-request-options"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/use-x-agent/index.zh-CN.md?type=demo')
};